// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { readParameterFromRouterState } from '@app/core';
import { UserDetailsFacadeService } from '@app/access-management/state/user-details/user-details.facade';
import { Observable } from 'rxjs';
import {
  UserState,
  UserRoleState,
  UserGroupsState
} from '@app/access-management/state/user-details/user-details.interfaces';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {
  rolesColumns = [{ name: 'Role', prop: 'name' }];
  user$: Observable<UserState>;
  userRoles$: Observable<UserRoleState[]>;
  userGroups$: Observable<UserGroupsState[]>;
  username: any = '';

  constructor(private activatedRoute: ActivatedRoute, private userDetailsFacade: UserDetailsFacadeService) {
    this.username = readParameterFromRouterState(this.activatedRoute, 'username');
    if (!this.username) {
      throw new Error('role id not in route');
    }

    this.userDetailsFacade.initialize(this.username);
    this.user$ = this.userDetailsFacade.user$;
    this.userRoles$ = this.userDetailsFacade.userRoles$;
    this.userGroups$ = this.userDetailsFacade.userGroups$;
  }

  ngOnInit(): void {}
}



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details.component.ts